import { __decorate, __metadata } from "tslib";
import { MutableStore } from "../../../store";
import { injectable } from "inversify";
import { extractQueryParamsFromUrl } from "../../../util/url";
export class TranslationEditorState {
    constructor() {
        this.enabled = false;
    }
}
let TranslationEditorContext = class TranslationEditorContext extends MutableStore {
    constructor() {
        super(new TranslationEditorState());
    }
    detectModeFromUrl() {
        const queryParams = extractQueryParamsFromUrl(window.location.href);
        if (queryParams.has("translate") && queryParams.get("translate") === "false") {
            this.enable();
        }
        else {
            this.disable();
        }
    }
    enable() {
        this.mutate(state => {
            state.enabled = true;
            return state;
        });
    }
    disable() {
        this.mutate(state => {
            state.enabled = false;
            return state;
        });
    }
};
TranslationEditorContext = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], TranslationEditorContext);
export { TranslationEditorContext };
//# sourceMappingURL=TranslationEditorContext.js.map